import Api from "../ApiUtility/Api";

class CkDictionaryDs {
    constructor() {
        this.api = new Api();
    }

    CK_Dictionary_List_GET() {
        return this.api.postAPI({}, '/dev/WS_CK_Dictionary_List_Get')
            .then(data => {
                console.log("parsed data", data)
                return data;
            })
            .catch(error => {
                console.error('Error during User Authentication API call :', error);
                throw error;
            });
    }

    CK_Dictionary_Object_By_ID_GET(requestData) {
        return this.api
            .postAPI(requestData, "/dev/WS_CK_Dictionary_Object_By_ID_GET")
            .then((data) => {
                console.log("Parsed Data :", data);
                return data;
            })
            .catch((error) => {
                console.error("Error during Dataset API call:", error);
                throw error;
            });
    }

    CK_Dictionary_Insert(requestData) {
        return this.api
            .postAPI(requestData, "/dev/WS_CK_Dictionary_Insert")
            .then((data) => {
                console.log("Parsed Data :", data);
                return data;
            })
            .catch((error) => {
                console.error("Error during Dataset API call:", error);
                throw error;
            });
    }

    CK_Dictionary_Update(requestData) {
        return this.api
            .postAPI(requestData, "/dev/WS_CK_Dictionary_Update")
            .then((data) => {
                console.log("Parsed Data :", data);
                return data;
            })
            .catch((error) => {
                console.error("Error during Dataset API call:", error);
                throw error;
            });
    }


    CK_Dictionary_Insert_Paritial(requestData) {
        return this.api
            .postAPI(requestData, "/dev/WS_CK_Dictionary_Partial_Insert")
            .then((data) => {
                console.log("Parsed Data :", data);
                return data;
            })
            .catch((error) => {
                console.error("Error during Dataset API call:", error);
                throw error;
            });
    }

    CK_Dictionary_Update_Paritial(requestData) {
        return this.api
            .postAPI(requestData, "/dev/WS_CK_Dictionary_Partial_Update")
            .then((data) => {
                console.log("Parsed Data :", data);
                return data;
            })
            .catch((error) => {
                console.error("Error during Dataset API call:", error);
                throw error;
            });
    }

    CK_Dictionary_Partial_Delete(requestData) {
        return this.api
            .postAPI(requestData, "/dev/WS_CK_Dictionary_Partial_Delete")
            .then((data) => {
                console.log("Parsed Data :", data);
                return data;
            })
            .catch((error) => {
                console.error("Error during Dataset API call:", error);
                throw error;
            });
    }

    WS_CK_Dictionary_Icon_Update(requestData) {
        return this.api
        .postAPI(requestData, "/dev/WS_CK_Dictionary_Icon_Update")
        .then((data) => {
            console.log("Parsed Data :", data);
            return data;
        })
        .catch((error) => {
            console.error("Error during Dataset API call:", error);
            throw error;
        });
    }
}

export default CkDictionaryDs;